import React, { HTMLAttributes } from "react";

import classnames from "classnames";

import { StyledDialogContent } from "./Styles";
// import { useDialogContext } from "./DialogContext";

export const DialogContent = ({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => {
  // useDialogContext();

  return (
    <StyledDialogContent
      className={classnames("c-dialog-content", className)}
      {...rest}
    >
      {children}
    </StyledDialogContent>
  );
};

DialogContent.displayName = "DialogContent";
